import React, { useState } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { motion } from 'framer-motion';
import { ArrowLeft, Package, X, Star, Shield, Award, MessageCircle, Phone } from 'lucide-react';
import ScrollToTop from '../components/ScrollToTop';
import WhatsAppButton from '../components/WhatsAppButton';

interface Product {
  id: string;
  name: string;
  code: string;
  image: string;
}

const Products: React.FC = () => {
  const { t, language } = useLanguage();
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const [selectedProduct, setSelectedProduct] = useState<Product | null>(null);

  const productCategories = [
    {
      id: 'fire-fighting',
      titleTr: 'Yangınla Mücadele',
      titleEn: 'Fire Fighting',
      image: '/resimler/fire.jpg',
      productCount: 38
    },
    {
      id: 'life-saving',
      titleTr: 'Can Kurtarma Ekipmanları',
      titleEn: 'Life Saving Equipment',
      image: '/resimler/life.jpg',
      productCount: 31
    },
    {
      id: 'personal-protective',
      titleTr: 'Kişisel Koruma Ekipmanları',
      titleEn: 'Personal Protective Equipment',
      image: '/resimler/resp.jpg',
      productCount: 17
    },
    {
      id: 'gas-detection',
      titleTr: 'Gaz Ölçüm Cihazları',
      titleEn: 'Gas Detection Devices',
      image: '/resimler/olc.png',
      productCount: 5
    },
    {
      id: 'medical-equipment',
      titleTr: 'Medikal Ekipmanlar',
      titleEn: 'Medical Equipment',
      image: '/resimler/aid.jpg',
      productCount: 9
    },
    {
      id: 'oil-spill',
      titleTr: 'Petrol Sızıntı Ekipmanları',
      titleEn: 'Oil Spill Equipment',
      image: '/resimler/oil.jpg',
      productCount: 15
    },
    {
      id: 'navigation-equipment',
      titleTr: 'Navigasyon Ekipmanları',
      titleEn: 'Navigation Equipment',
      image: '/resimler/nav.jpg',
      productCount: 10
    },
    {
      id: 'life-boat-davit',
      titleTr: 'Can Kurtaran Botları ve DAVIT',
      titleEn: 'Life Boat and DAVIT',
      image: '/resimler/boat.jpg',
      productCount: 4
    }
  ];

  
  const getProductsByCategory = (categoryId: string): Product[] => {
    
    const productData: Record<string, Product[]> = {
      'fire-fighting': [
       { id: 'ff-001', name: language === 'tr' ? 'Yangın Battaniyesi' : 'Fire Blanket', code: 'impa Kodu: 2131', image: '/urunler/yangınla mücadele ekipmanları/1.JPG' },
        { id: 'ff-002', name: language === 'tr' ? 'Solunum Seti Hava Tüpü' : 'Breathing Apparatus Air Cylinder', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/2.JPG' },
        { id: 'ff-003', name: language === 'tr' ? 'Tüp Dolabı' : 'Tube Cabinet', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/3.JPG' },
        { id: 'ff-004', name: language === 'tr' ? '1,5″, 2″, 2,5″ Beyaz – Kırmızı Renk Hortum' : '1,5″, 2″, 2,5″ White – Red Color Hose', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/4.JPG' },
        { id: 'ff-005', name: language === 'tr' ? 'Alumunıze Çizme' : 'Aluminize Boots', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/5.JPG' },
        { id: 'ff-006', name: language === 'tr' ? 'Alumunıze Kemer' : 'Aluminum Belt', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/6.JPG' },
        { id: 'ff-007', name: language === 'tr' ? '50 Kg Yangın Söndürme' : '50 kg Fire Extinguisher', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/7.JPG' },
        { id: 'ff-009', name: language === 'tr' ? 'Yangıncı Çizmesi' : 'Fireman Boots', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/8.JPG' },
        { id: 'ff-009', name: language === 'tr' ? 'Acil Kaçış Solunum Tüpü Valfi' : 'Emergency Escape Breathing Tube Valve', code: 'impa kodu :22 ', image: '/urunler/yangınla mücadele ekipmanları/9.JPG' },
        { id: 'ff-011', name: language === 'tr' ? 'Hava Tüpü' : 'Air Tube', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/11.JPG' },
        { id: 'ff-012', name: language === 'tr' ? '2 Kg Yangın Söndürme Tüpü' : '2 kg Fire Extinguisher', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/12.JPG' },
        { id: 'ff-013', name: language === 'tr' ? 'Yangın Hortum Dolabı Kare Tip' : 'Fire Hose Cabinet Hose Type', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/13.JPG' },
        { id: 'ff-014', name: language === 'tr' ? 'Yangın Hortum Dolabı D Tip' : 'Fire Hose Cabinet D Type', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/14.JPG' },
        { id: 'ff-016', name: language === 'tr' ? 'Nomex Ceket + Pantolon İtfaiyeci' : 'Nomex Fireman Coat and Trosuers', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/16.JPG' },
        { id: 'ff-017', name: language === 'tr' ? 'Yangın Plan Kutusu' : 'Fire Plan Box', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/17.JPG' },
        { id: 'ff-018', name: language === 'tr' ? '5 Kg CO2 Yangın Söndürme Tüpü' : '5 Kg CO2 Fire Extinguisher', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/18.JPG' },
        { id: 'ff-019', name: language === 'tr' ? '12 Kg Yangın Söndürme Tüpü' : '12 kg Fire Extinguisher', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/19.JPG' },
        { id: 'ff-020', name: language === 'tr' ? 'Nozul' : 'nozzle', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/20.JPG' },
        { id: 'ff-021', name: language === 'tr' ? 'Tüp Kemeri Kısa Ve Uzun' : 'Tube Belt Short and Long', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/21.JPG' },
        { id: 'ff-022', name: language === 'tr' ? 'Yanmaz Eldiven' : 'Fireproof Gloves', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/22.JPG' },
        { id: 'ff-023', name: language === 'tr' ? 'Alumunıze Eldiven' : 'Alumunıze Gloves', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/23.JPG' },
        { id: 'ff-024', name: language === 'tr' ? 'Yangıncı Bareti' : 'Fireman Helmet', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/24.JPG' },
        { id: 'ff-025', name: language === 'tr' ? 'Balta' : 'Ax', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/25.JPG' },
        { id: 'ff-026', name: language === 'tr' ? 'Hava Tüpü Valfi' : 'Breathing Apparatus Air Cylinder Valve', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/26.JPG' },
        { id: 'ff-027', name: language === 'tr' ? 'Hortum Sarma Teli (Krom Tel)' : 'Hose Wrapping Wire (Chrome Wire)', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/27.JPG' },
        { id: 'ff-028', name: language === 'tr' ? 'Alumunize Ceket + Pantalon + Başlık' : 'Aluminized Jacket + Trousers + Hood', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/28.JPG' },
        { id: 'ff-029', name: language === 'tr' ? 'Hava Tüpü Kontrol Basınç Göstergesi' : 'Air Tank Control Pressure Gauge', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/29.JPG' },
        { id: 'ff-030', name: language === 'tr' ? 'Alman – Nakajıma (Japon) – İtalyan – İngiliz – Rus – İspanyol – Amerikan – Machino – Fransız İç Dişli Rekorlar' : 'German – Nakajima (Japanese) – Italian – British – Russian – Spanish – American – Machino – French Internal Gear Records', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/30.JPG' },
        { id: 'ff-031', name: language === 'tr' ? 'Tüp Braketi (6Kg – 12 Kg – 9 Ltr Foam – 5Kg Co2)' : 'Tube Bracket (6Kg – 12 Kg – 9 Ltr Foam – 5Kg Co2)', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/31.JPG' },
        { id: 'ff-032', name: language === 'tr' ? 'Yangıncı Kemer' : 'Fireman Belt', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/32.JPG' },
        { id: 'ff-033', name: language === 'tr' ? 'Acil Kaçış Solunum Cihazı' : 'Emergency Escape Breathing Device', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/33.JPG' },
        { id: 'ff-034', name: language === 'tr' ? 'Yanmaz Can Halatı' : 'Fireproof Lifeline', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/34.JPG' },
        { id: 'ff-035', name: language === 'tr' ? 'Yangın Vanaları' : 'Fire Valves', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/35.JPG' },
        { id: 'ff-036', name: language === 'tr' ? '1,5 – 2, – 2,5 Conta' : '1.5 – 2.5 – 2.5 Gasket', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/36.JPG' },
        { id: 'ff-037', name: language === 'tr' ? '9 Ltr Foam Yangın Söndürme Tüpü' : '9 Ltr Foam Fire Extinguisher', code: 'impa kodu : ', image: '/urunler/yangınla mücadele ekipmanları/37.JPG' },
      
      ],
      'life-saving': [
        { id: 'ls-001', name: language === 'tr' ? 'Pains Wessex Manoverboard' : 'Pains Wessex Manoverboard', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/1.JPG' },
        { id: 'ls-002', name: language === 'tr' ? 'Çamcak' : 'Bailer', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/2.JPG' },
        { id: 'ls-003', name: language === 'tr' ? 'Pilot Merdiveni' : 'Pilot Ladder', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/3.JPG' },
        { id: 'ls-004', name: language === 'tr' ? 'Rescue Boat Tamir Kiti' : 'Rescue Boat Repair Kit', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/4.JPG' },
        { id: 'ls-005', name: language === 'tr' ? 'Can Simidi Işığı 5 Yıllık Bataryalı' : 'ATEX Exproof-Lifebuoy Light ATEX Exproof with 5-Year Battery', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/5.JPG' },
        { id: 'ls-006', name: language === 'tr' ? 'Can Yeleği' : 'Life Jacket', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/6.JPG' },
        { id: 'ls-007', name: language === 'tr' ? 'Işıklı Şamandra Exproff' : 'Illuminated Buoy Exproff', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/7.JPG' },
        { id: 'ls-008', name: language === 'tr' ? 'Safetmade HRU LR-2' : 'Safetmade HRU LR-2', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/8.JPG' },
        { id: 'ls-009', name: language === 'tr' ? 'Pelikanlı Kuşak' : 'Pelican Belt', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/9.JPG' },
        { id: 'ls-010', name: language === 'tr' ? 'Embarkation Ladder' : 'Embarkation Ladder', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/10.JPG' },
        { id: 'ls-011', name: language === 'tr' ? 'Can Simidi' : 'Lifebuoy', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/11.JPG' },
        { id: 'ls-012', name: language === 'tr' ? 'Duman Kandili' : 'Smoke Lamp', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/12.JPG' },
        { id: 'ls-013', name: language === 'tr' ? 'Kurtarma Botu Işığı' : 'Search Light for Lifeboat', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/13.JPG' },
        { id: 'ls-014', name: language === 'tr' ? 'Can Salı Liferaft David Launchable' : 'Can Salı Liferaft David Launchable', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/14.JPG' },
        { id: 'ls-015', name: language === 'tr' ? 'Kağıt Bant – İkaz Bant – Hortum Sarma Bant (Gri Bant)' : 'Paper Tape – Warning Tape – Hose Wrap Tape (Gray Tape)', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/15.JPG' },
        { id: 'ls-016', name: language === 'tr' ? 'Can Simidi Braketi' : 'Lifebuoy Bracket', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/16.JPG' },
        { id: 'ls-017', name: language === 'tr' ? 'Şişirilebilir Can Yeleği' : 'Inflatable Life Jacket', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/17.JPG' },
        { id: 'ls-018', name: language === 'tr' ? 'Paraşüt İşaret Fişeği' : 'Parachute Flare', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/18.JPG' },
        { id: 'ls-019', name: language === 'tr' ? 'Solas Reflektor Bant' : 'Solas Reflector Tape', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/19.JPG' },
        { id: 'ls-020', name: language === 'tr' ? 'ID Kart Kutusu' : 'ID Card Box', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/20.JPG' },
        { id: 'ls-021', name: language === 'tr' ? 'Can Simidi Işığı' : 'Lifebuoy Light', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/21.JPG' },
        { id: 'ls-022', name: language === 'tr' ? 'Yüzer Çakı' : 'Floating Pocket Knife', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/22.JPG' },
        { id: 'ls-023', name: language === 'tr' ? 'Rescue Boat Tepe Lambası' : 'Rescue Boat Beacon Light', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/23.JPG' },
        { id: 'ls-024', name: language === 'tr' ? 'Düdük' : 'whistle', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/24.JPG' },
        { id: 'ls-025', name: language === 'tr' ? 'Akana Su' : 'Akana Water', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/25.JPG' },
        { id: 'ls-026', name: language === 'tr' ? 'Halat Atar Set' : 'Rope Throw Set', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/26.JPG' },
        { id: 'ls-027', name: language === 'tr' ? 'Daldırma Elbisesi' : 'Immersion Suit', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/27.JPG' },
        { id: 'ls-028', name: language === 'tr' ? 'Can Salı Hidrostatik Kilit' : 'Hydrostatic Release Unit for Liferaft', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/28.JPG' },
        { id: 'ls-029', name: language === 'tr' ? 'Kutulu Can Simidi İpi' : 'Boxed Lifebuoy Rope', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/29.JPG' },
        { id: 'ls-030', name: language === 'tr' ? 'Sintine Pompası' : 'Bilge Pump', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/30.JPG' },
        { id: 'ls-031', name: language === 'tr' ? 'Seven Oceans Su & Gıda' : 'Seven Oceans Water & Food', code: 'impa kodu : ', image: '/urunler/can kurtarma ekipmanları/31.JPG' }
      ],
      'personal-protective': [
        { id: 'pp-001', name: language === 'tr' ? 'Dolap Kilidi' : 'Cabinet Lock', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/1.JPG' },
        { id: 'pp-002', name: language === 'tr' ? 'Jop' : 'Jop', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/2.JPG' },
        { id: 'pp-003', name: language === 'tr' ? 'Vizör' : 'Viewfinder', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/3.JPG' },
        { id: 'pp-004', name: language === 'tr' ? 'Güvenlik Bareti' : 'Safety Helmet', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/4.JPG' },
        { id: 'pp-005', name: language === 'tr' ? 'Kimyasal Eldiven' : 'Chemical Gloves', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/5.JPG' },
        { id: 'pp-006', name: language === 'tr' ? 'Pilli El Fenerleri' : 'Battery-Powered Flashlights', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/6.JPG' },
        { id: 'pp-007', name: language === 'tr' ? 'Kafa Feneri' : 'Headlamp', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/7.JPG' },
        { id: 'pp-008', name: language === 'tr' ? 'Şarjlı El Feneri' : 'Rechargeable Flashlight', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/8.JPG' },
        { id: 'pp-009', name: language === 'tr' ? 'Kimyasal Çizme' : 'Chemical Boot', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/9.JPG' },
        { id: 'pp-010', name: language === 'tr' ? 'İkaz Yeleği' : 'Warning Vest', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/10.JPG' },
        { id: 'pp-011', name: language === 'tr' ? 'Üst Arama Dedektörü' : 'Body Search Detector', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/11.JPG' },
        { id: 'pp-012', name: language === 'tr' ? 'Kimyasal Tulum' : 'Chemical Coverall', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/12.JPG' },
        { id: 'pp-013', name: language === 'tr' ? 'Kelepçe' : 'Handcuff', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/13.JPG' },
        { id: 'pp-014', name: language === 'tr' ? 'Kimyasal Gözlük' : 'Chemical Glasses', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/14.JPG' },
        { id: 'pp-015', name: language === 'tr' ? 'Paraşüt Tip Emniyet Kemeri' : 'Parachute Type Safety Belt', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/15.JPG' },
        { id: 'pp-016', name: language === 'tr' ? 'Uvex Kimyasal Gözlük' : 'Uvex Chemical Glasses', code: 'impa kodu : ', image: '/urunler/kişisel koruma ekipmanları/16.JPG' },
      ],
      'gas-detection': [
        { id: 'gd-001', name: language === 'tr' ? 'Regulator' : 'Regulator', code: 'impa kodu : ', image: '/urunler/gaz ölçüm cihazları/2.JPG' },
        { id: 'gd-002', name: language === 'tr' ? 'BW Max XT II Pompalı Çoklu Gaz Ölçüm Cihazı' : 'BW Max XT II Multi-Gas Measuring Device with Pump', code: 'impa kodu : ', image: '/urunler/gaz ölçüm cihazları/3.JPG' },
        { id: 'gd-003', name: language === 'tr' ? 'Alkolmetre' : 'Breathalyser', code: 'impa kodu : ', image: '/urunler/gaz ölçüm cihazları/4.JPG' },
        { id: 'gd-004', name: language === 'tr' ? 'GMI PS200 O2-LEL-CO-H2S Multi Gaz Dedektörü' : 'GMI PS200 O2-LEL-CO-H2S Multi Gas Detector', code: 'impa kodu : ', image: '/urunler/gaz ölçüm cihazları/5.JPG' },
        { id: 'gd-005', name: language === 'tr' ? 'Kalibrasyon Gazı' : 'Calibration Gas', code: 'impa kodu : ', image: '/urunler/gaz ölçüm cihazları/6.JPG' }
      ],
      'medical-equipment': [
        { id: 'me-001', name: language === 'tr' ? 'Vakumlu İlk Yardım' : 'Vacuum First Aid', code: 'impa kodu :', image: '/urunler/medikal ekipmanlar/1.JPG' },
        { id: 'me-002', name: language === 'tr' ? 'Çiftli Terapi Seti' : 'Double Therapy Set', code: 'impa kodu : ', image: '/urunler/medikal ekipmanlar/2.JPG' },
        { id: 'me-003', name: language === 'tr' ? 'Tekli Terapi Seti' : 'Single Therapy Set', code: 'impa kodu : ', image: '/urunler/medikal ekipmanlar/3.JPG' },
        { id: 'me-004', name: language === 'tr' ? 'Kutulu İlk Yardım Çantası' : 'Boxed First Aid Kit', code: 'impa kodu : ', image: '/urunler/medikal ekipmanlar/4.JPG' },
        { id: 'me-005', name: language === 'tr' ? 'Pin Index Regulator' : 'Pin Index Regulator', code: 'impa kodu : ', image: '/urunler/medikal ekipmanlar/5.JPG' },
        { id: 'me-006', name: language === 'tr' ? 'Metpamid Bulantı Hapı' : 'Metpamid Nausea Pill', code: '12345', image: '/urunler/medikal ekipmanlar/6.JPG' },
        { id: 'me-007', name: language === 'tr' ? '2LTR – 5LTR – 10LTR – 40LTR Medikal Oksijen Tüpü' : '2LTR – 5LTR – 10LTR – 40LTR Medical Oxygen Cylinder', code: 'impa kodu : ', image: '/urunler/medikal ekipmanlar/7.JPG' },
        { id: 'me-008', name: language === 'tr' ? 'Göz Yıkama Suyu' : 'Eye Wash', code: '12345', image: '/urunler/medikal ekipmanlar/8.JPG' },
        { id: 'me-009', name: language === 'tr' ? 'Pin Index Medikal Tüp' : 'Pin Index Medical Tube', code: '12345', image: '/urunler/medikal ekipmanlar/9.JPG' }
      ],
      'oil-spill': [
        { id: 'os-001', name: language === 'tr' ? '2 Ltr İlaçlama Pompası' : '2 Ltr Spraying Pump', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/1.JPG' },
        { id: 'os-002', name: language === 'tr' ? 'Vizör' : 'Viewfinder', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/2.JPG' },
        { id: 'os-003', name: language === 'tr' ? 'Yağ Emici Roll' : 'Oil Absorbent Roll', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/3.JPG' },
        { id: 'os-004', name: language === 'tr' ? 'Kimyasal Çizme' : 'Chemical Boots', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/4.JPG' },
        { id: 'os-005', name: language === 'tr' ? 'Kimyasal Eldiven' : 'Chemical Gloves', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/5.JPG' },
        { id: 'os-006', name: language === 'tr' ? 'Kıvılcım Çıkarmaz Kürek' : 'Non-Sparking Shovel', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/6.JPG' },
        { id: 'os-007', name: language === 'tr' ? 'Osd (Yağ Çökertici)' : 'OSD (Fat Separator)', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/7.JPG' },
        { id: 'os-008', name: language === 'tr' ? 'Çekpas' : 'Squeegee', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/8.JPG' },
        { id: 'os-009', name: language === 'tr' ? 'Siyah Çöp Torbası' : 'Black Trash Bag', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/9.JPG' },
        { id: 'os-010', name: language === 'tr' ? 'Kimyasal Tulum' : 'Chemical Coverall', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/10.JPG' },
        { id: 'os-011', name: language === 'tr' ? 'Yağ Emici Sosis' : 'Fat Absorbing Sausage', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/11.JPG' },
        { id: 'os-012', name: language === 'tr' ? 'Yağ Emici Yastık' : 'Oil Absorbent Pillow', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/12.JPG' },
        { id: 'os-013', name: language === 'tr' ? 'Kimyasal Gözlük' : 'Chemical Glasses', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/13.JPG' },
        { id: 'os-014', name: language === 'tr' ? 'Yağ Emici Pad' : 'Oil Absorbent Pad', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/14.JPG' },
        { id: 'os-015', name: language === 'tr' ? 'Uvex Kimyasal Gözlük' : 'Uvex Chemical Goggles', code: 'impa kodu : ', image: '/urunler/petrol sızıntı ekipmanları/15.JPG' }
      ],
      'navigation-equipment': [
        { id: 'ne-001', name: language === 'tr' ? 'Dürbün' : 'Binoculars', code: 'impa kodu : ', image: '/urunler/navigasyon ekipmanları/1.JPG' },
        { id: 'ne-002', name: language === 'tr' ? 'Telsiz' : 'Radio', code: 'impa kodu : ', image: '/urunler/navigasyon ekipmanları/2.JPG' },
        { id: 'ne-003', name: language === 'tr' ? 'Islak Kuru Termometre' : 'Wet Dry Thermometer', code: 'impa kodu : ', image: '/urunler/navigasyon ekipmanları/3.JPG' },
        { id: 'ne-004', name: language === 'tr' ? 'Yalpametre' : 'Clino Meter', code: 'impa kodu : ', image: '/urunler/navigasyon ekipmanları/4.JPG' },
        { id: 'ne-005', name: language === 'tr' ? 'Gündüz İşaret Koni' : 'Day Sign Cone', code: 'impa kodu : ', image: '/urunler/navigasyon ekipmanları/5.JPG' },
        { id: 'ne-006', name: language === 'tr' ? 'Gündüz İşaret Küre' : 'Day Sign Globe', code: 'impa kodu : ', image: '/urunler/navigasyon ekipmanları/6.JPG' },
        { id: 'ne-007', name: language === 'tr' ? 'Gündüz İşaret Eşkenar' : 'Day Sign Equilateral', code: 'impa kodu : ', image: '/urunler/navigasyon ekipmanları/7.JPG' },
        { id: 'ne-008', name: language === 'tr' ? 'Gündüz İşaret Silindir' : 'Day Sign Cylinder', code: 'impa kodu : ', image: '/urunler/navigasyon ekipmanları/8.JPG' },
        { id: 'ne-009', name: language === 'tr' ? 'Kronometre' : 'Stopwatch', code: 'impa kodu : ', image: '/urunler/navigasyon ekipmanları/9.JPG' },
        { id: 'ne-010', name: language === 'tr' ? 'Pusula' : 'Compass', code: 'impa kodu : ', image: '/urunler/navigasyon ekipmanları/10.JPG' }
      ],
      'life-boat-davit': [
        { id: 'ld-001', name: language === 'tr' ? 'Can Kurtaran Botu 6 Kişilik' : '6-Person Lifeboat', code: 'AYM-DA-001 ', image: '/resimler/1.jpg' },
        { id: 'ld-002', name: language === 'tr' ? 'Can Kurtaran Botu 25 Kişilik' : '25-Person Lifeboat', code: 'AYM-DA-002 ', image: '/resimler/boat.jpg' },
        { id: 'ld-003', name: language === 'tr' ? 'Davit Sistemi Tek Kol' : 'Single Arm Davit System', code: 'AYM-DA-003 ', image: '/resimler/boat3.jpg' },
        { id: 'ld-004', name: language === 'tr' ? 'Davit Sistemi Çift Kol' : 'Double Arm Davit System', code: 'AYM-DA-005', image: '/resimler/boat4.jpg' }
      ]
    };

    return productData[categoryId] || [];
  };

  const handleCategoryClick = (categoryId: string) => {
    setSelectedCategory(categoryId);
  };

  const handleBackToCategories = () => {
    setSelectedCategory(null);
  };

  const handleProductClick = (product: Product) => {
    setSelectedProduct(product);
  };

  const handleCloseProductDetail = () => {
    setSelectedProduct(null);
  };

  const getProductDetails = (product: Product) => {
    return {
      description: language === 'tr' 
        ? `${product.name} yüksek kaliteli malzemelerden üretilmiş, uluslararası standartlara uygun bir üründür. Denizcilik sektöründe güvenlik ve kalite önceliğimizdir.`
        : `${product.name} is manufactured from high-quality materials and complies with international standards. Safety and quality are our priority in the maritime industry.`,
      features: language === 'tr' 
        ? ['CE Sertifikalı', 'Uluslararası Standartlarda', '2 Yıl Garanti', 'Hızlı Teslimat', 'Teknik Destek']
        : ['CE Certified', 'International Standards', '2 Year Warranty', 'Fast Delivery', 'Technical Support'],
      specifications: language === 'tr'
        ? {
            'Malzeme': 'Yüksek Kalite Çelik/Plastik',
            'Sertifika': 'CE, MED Onaylı',
            'Garanti': '2 Yıl',
            'Menşei': 'Türkiye/AB',
            'Teslimat': '3-5 İş Günü'
          }
        : {
            'Material': 'High Quality Steel/Plastic',
            'Certificate': 'CE, MED Approved',
            'Warranty': '2 Years',
            'Origin': 'Turkey/EU',
            'Delivery': '3-5 Business Days'
          }
    };
  };

  const selectedCategoryData = productCategories.find(cat => cat.id === selectedCategory);
  const categoryProducts = selectedCategory ? getProductsByCategory(selectedCategory) : [];

  
  if (selectedProduct) {
    const productDetails = getProductDetails(selectedProduct);
    
    return (
      <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.9 }}
          className="bg-slate-800 rounded-lg max-w-6xl w-full max-h-[90vh] overflow-y-auto"
        >
          
          <div className="sticky top-0 bg-slate-800 p-4 border-b border-slate-700 flex justify-between items-center">
            <h2 className="text-xl font-bold text-white">{language === 'tr' ? 'Ürün Detayı' : 'Product Details'}</h2>
            <button
              onClick={handleCloseProductDetail}
              className="text-slate-400 hover:text-white transition-colors duration-200"
            >
              <X className="h-6 w-6" />
            </button>
          </div>

          <div className="p-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
             
              <div className="space-y-4">
                <div className="relative">
                  <img
                    src={selectedProduct.image}
                    alt={selectedProduct.name}
                    className="w-full h-96 lg:h-[500px] object-cover rounded-lg"
                  />
                  <div className="absolute top-4 right-4">
                    <div className="bg-amber-400 text-slate-900 px-3 py-2 rounded text-sm font-semibold">
                      {selectedProduct.code}
                    </div>
                  </div>
                </div>
              </div>

              
              <div className="space-y-6">
                
                <div>
                  <h1 className="text-2xl lg:text-3xl font-bold text-white mb-2">
                    {selectedProduct.name}
                  </h1>
                  <p className="text-amber-400 text-lg font-semibold">
                  {language === 'tr' ? 'İmpa Kodu:' : 'IMPA Code:'} {selectedProduct.code}
                  </p>

                </div>

                
                <div>
                  <h3 className="text-lg font-semibold text-amber-400 mb-3">
                    {language === 'tr' ? 'Açıklama' : 'Description'}
                  </h3>
                  <p className="text-slate-300 leading-relaxed">
                    {productDetails.description}
                  </p>
                </div>

               
                <div>
                  <h3 className="text-lg font-semibold text-amber-400 mb-3">
                    {language === 'tr' ? 'Özellikler' : 'Features'}
                  </h3>
                  <ul className="space-y-2">
                    {productDetails.features.map((feature, index) => (
                      <li key={index} className="flex items-center space-x-2 text-slate-300">
                        <Shield className="h-4 w-4 text-green-400" />
                        <span>{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                
                <div>
                  <h3 className="text-lg font-semibold text-amber-400 mb-3">
                    {language === 'tr' ? 'Teknik Özellikler' : 'Specifications'}
                  </h3>
                  <div className="bg-slate-700 rounded-lg p-4">
                    {Object.entries(productDetails.specifications).map(([key, value]) => (
                      <div key={key} className="flex justify-between py-2 border-b border-slate-600 last:border-b-0">
                        <span className="text-slate-400">{key}:</span>
                        <span className="text-white font-medium">{value}</span>
                      </div>
                    ))}
                  </div>
                </div>

                
                <div className="flex flex-col sm:flex-row gap-4 pt-4">
                  <button
                    onClick={() => {
                      const message = `Merhaba, ${selectedProduct.name} (${selectedProduct.code}) hakkında bilgi almak istiyorum.`;
                      const url = `https://wa.me/905468335666?text=${encodeURIComponent(message)}`;
                      window.open(url, '_blank');
                    }}
                    className="flex items-center justify-center space-x-2 bg-green-500 hover:bg-green-600 text-white px-6 py-3 rounded-lg transition-colors duration-200"
                  >
                    <MessageCircle className="h-5 w-5" />
                    <span>WhatsApp</span>
                  </button>
                  
                  <button
                    onClick={() => {
                      handleCloseProductDetail();
                     
                      window.location.href = '/contact';
                    }}
                    className="flex items-center justify-center space-x-2 bg-amber-400 hover:bg-amber-500 text-slate-900 px-6 py-3 rounded-lg transition-colors duration-200"
                  >
                    <Phone className="h-5 w-5" />
                    <span>{language === 'tr' ? 'İletişim' : 'Contact'}</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    );
  }

  if (selectedCategory) {
    return (
      <>
        <div className="min-h-screen bg-slate-900 text-white py-16">
        <div className="container mx-auto px-4">
          
          <motion.button
            onClick={handleBackToCategories}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center space-x-2 text-amber-400 hover:text-amber-300 mb-8 transition-colors duration-200"
          >
            <ArrowLeft className="h-5 w-5" />
            <span>{language === 'tr' ? 'Kategorilere Dön' : 'Back to Categories'}</span>
          </motion.button>

         
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white">
              {language === 'tr' ? selectedCategoryData?.titleTr : selectedCategoryData?.titleEn}
            </h1>
            <div className="w-24 h-1 bg-amber-400 mx-auto mb-6"></div>
            <p className="text-xl text-gray-300">
              {selectedCategoryData?.productCount} {language === 'tr' ? 'Ürün' : 'Products'}
            </p>
          </motion.div>

         
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {categoryProducts.map((product, index) => (
              <motion.div
                key={product.id}
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.05, duration: 0.6 }}
                className="bg-slate-800 rounded-lg overflow-hidden shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105 border border-slate-700 cursor-pointer"
                onClick={() => handleProductClick(product)}
              >
                <div className="relative h-64 overflow-hidden">
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-110"
                  />
                  <div className="absolute top-3 right-3">
                    <div className="bg-amber-400 text-slate-900 px-3 py-2 rounded text-sm font-semibold">
                      {product.code}
                    </div>
                  </div>
                </div>
                <div className="p-6">
                  <h3 className="text-xl font-semibold text-white mb-3 line-clamp-2">
                    {product.name}
                  </h3>
                  <div className="flex items-center justify-between">
                    <span className="text-gray-400 text-base font-medium">{product.code}</span>
                    <Package className="h-5 w-5 text-amber-400" />
                  </div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
        </div>
        
        <ScrollToTop />
        <WhatsAppButton />
      </>
    );
  }

  return (
    <div className="min-h-screen bg-slate-900 text-white py-16">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16"
        >
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-white">
            {t('productsTitle')}
          </h1>
          <div className="w-24 h-1 bg-amber-400 mx-auto"></div>
        </motion.div>

      
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          {productCategories.map((category, index) => (
            <motion.div
              key={category.id}
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1, duration: 0.6 }}
              className={`group cursor-pointer ${
                productCategories.length === 7 && index === 6 
                  ? 'md:col-span-2 lg:col-span-3 xl:col-span-4 max-w-md mx-auto' 
                  : ''
              }`}
              onClick={() => handleCategoryClick(category.id)}
            >
              <div className="relative overflow-hidden rounded-lg shadow-xl hover:shadow-2xl transition-all duration-300 hover:scale-105">
              
                <div className="relative h-80 overflow-hidden">
                  <img
                    src={category.image}
                    alt={language === 'tr' ? category.titleTr : category.titleEn}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent opacity-70"></div>
                  
                
                  <div className="absolute top-4 right-4">
                    <div className="bg-amber-400 bg-opacity-90 text-slate-900 px-3 py-1 rounded-full text-sm font-semibold">
                      {category.productCount} {language === 'tr' ? 'Ürün' : 'Products'}
                    </div>
                  </div>
                  
                 
                  <div className="absolute bottom-0 left-0 right-0 p-6">
                    <div className="bg-amber-400 bg-opacity-90 p-4 rounded-lg">
                      <h3 className="text-xl font-bold text-slate-900 text-center">
                        {language === 'tr' ? category.titleTr : category.titleEn}
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

     
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.8, duration: 0.8 }}
          className="mt-16 text-center"
        >
          <div className="bg-slate-800 rounded-lg p-8 border border-slate-700">
            <h2 className="text-2xl font-bold mb-6 text-amber-400">
              {language === 'tr' ? 'IMO E-Katalog' : 'IMO E-Catalog'}
            </h2>
            <p className="text-slate-300 text-lg leading-relaxed max-w-4xl mx-auto mb-8">
              {language === 'tr' 
                ? 'Tüm ürünlerimizin detaylı bilgilerini, teknik özelliklerini ve fiyat listesini içeren kapsamlı IMO e-kataloğunu indirin.'
                : 'Download our comprehensive IMO e-catalog containing detailed information, technical specifications and price list of all our products.'
              }
            </p>
          
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => {
                
                const link = document.createElement('a');
                link.href = '/catalog/aymer-product-catalog.pdf'; 
                link.download = 'IMO-E-Katalog.pdf'; 
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }}
              className="inline-flex items-center space-x-3 bg-amber-400 hover:bg-amber-500 text-slate-900 font-bold py-4 px-8 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
            >
              <svg 
                className="h-6 w-6" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth={2} 
                  d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" 
                />
              </svg>
              <span>
                {language === 'tr' ? 'IMO E-Katalog İndir (PDF)' : 'Download IMO E-Catalog (PDF)'}
              </span>
            </motion.button>
            
            <p className="text-slate-400 text-sm mt-4">
              {language === 'tr' 
                ? 'E-Katalog otomatik olarak cihazınıza indirilecektir'
                : 'IMO file will be automatically downloaded to your device'
              }
            </p>
          </div>
        </motion.div>
      </div>
      
      <ScrollToTop />
      <WhatsAppButton />
    </div>
  );
};

export default Products;